import React, { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, ModuleRegistry, AllCommunityModule, themeBalham } from 'ag-grid-community';
import { format } from 'date-fns';
import { DetailLivraison } from '../../../utils/types/DetailLivraison';

ModuleRegistry.registerModules([AllCommunityModule]);

const LastDeliveriesGrid: React.FC<{ items: DetailLivraison[] }> = ({ items }) => {
    const [columnDefs] = useState<ColDef<DetailLivraison>[]>([
        { field: 'codeManuel', headerName: 'No Bon' },
        {
            field: 'dateDocument',
            headerName: 'Date',
            valueFormatter: (p) => (p.value ? format(new Date(p.value), 'dd/MM/yyyy') : ''),
        },
        { field: 'pointDeVente', headerName: 'Station' },
        { field: 'designation', headerName: 'Produit' },
        { field: 'numeroCarte', headerName: 'Carte' },
        {
            field: 'quantite',
            headerName: 'Quantité (L)',
            type: 'numericColumn',
            valueFormatter: (p) => (p.value ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2 }).format(p.value) : ''),
        },
        {
            headerName: 'Total ($)',
            type: 'numericColumn',
            valueGetter: (p) => (p.data?.quantite && p.data?.prixDol ? p.data.quantite * p.data.prixDol : 0),
            valueFormatter: (p) => (p.value ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'USD' }).format(p.value) : ''),
        },
    ]);

    return (
        <div style={{ width: '100%', height: 200 }}>
            <AgGridReact theme={themeBalham} rowData={items} columnDefs={columnDefs} defaultColDef={{ flex: 1, resizable: true, sortable: false, minWidth: 100 }} overlayNoRowsTemplate="<span style='padding: 10px;'>Aucune donnée ...</span>" />
        </div>
    );
};

export default LastDeliveriesGrid;
